import { GetPageByRouteQuery } from "apollo"
import { Culture, transformProperties } from "utils"
import SmartBlocksRenderer from "../Common/SmartBlocksRenderer"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  culture: Culture
}

const pageComponents = {
  fAQ: () => import("./SimpleAccordion"),
}

export default async function PaymentApps({
  data,
  locale,
  culture,
}: Props): Promise<React.ReactElement> {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)

  return (
    <SmartBlocksRenderer
      blocks={blocks?.blocks || []}
      locale={locale}
      culture={culture}
      pageData={data}
      components={pageComponents}
    />
  )
}
